import type React from 'react';
import { ButtonHTMLAttributes } from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';

interface ToggleProps {
    value?: boolean;
    onToggle?: (state: boolean) => void;
    className?: string;
    disabled?: boolean;
}

export const Toggle: React.FC<ToggleProps> = ({ value = false, onToggle, ...props }) => {
    const handleClick = () => {
        onToggle && onToggle(!value);
    };

    return (
        <button
            {...props}
            className={cn(styles.toggle, { [styles.on]: value, [styles.off]: !value })}
            onClick={handleClick}
            type='button'
        >
            <div className={styles.toggle__circle} />
        </button>
    );
};
